import ThemedSvgIcon from './ThemedSvgIcon';

const MonitorIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.75 0.75C1.37109 0.75 0.25 1.87109 0.25 3.25V15.75C0.25 17.1289 1.37109 18.25 2.75 18.25H20.25C21.6289 18.25 22.75 17.1289 22.75 15.75V3.25C22.75 1.87109 21.6289 0.75 20.25 0.75H2.75ZM3.375 3.25H19.625C19.9688 3.25 20.25 3.53125 20.25 3.875V15.125C20.25 15.4688 19.9688 15.75 19.625 15.75H3.375C3.03125 15.75 2.75 15.4688 2.75 15.125V10.125V3.875C2.75 3.53125 3.03125 3.25 3.375 3.25ZM4 9.5H7.75C7.98828 9.5 8.20312 9.63281 8.30859 9.84375L9 11.2266L10.9414 7.34375C11.0469 7.13281 11.2656 7 11.5 7C11.7344 7 11.9531 7.13281 12.0586 7.34375L13.1367 9.5H15.875C16.2188 9.5 16.5 9.78125 16.5 10.125C16.5 10.4688 16.2188 10.75 15.875 10.75H12.75C12.5117 10.75 12.2969 10.6172 12.1914 10.4062L11.5 9.02344L9.55859 12.9062C9.45312 13.1172 9.23438 13.25 9 13.25C8.76562 13.25 8.54688 13.1172 8.44141 12.9062L7.36328 10.75H4V14.5H19V4.5H4V9.5Z"
                    fill={fill}
                />
            </svg>
        )}
    </ThemedSvgIcon>
);

export default MonitorIcon;
